import CorrectionType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  list: {
    loading: true,
    data: []
  }
}

const Correction = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CorrectionType.GET_CORRECTION_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case CorrectionType.GET_DETAIL_CORRECTION_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case CorrectionType.PUT_CORRECTION_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case CorrectionType.POST_CORRECTION_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case CorrectionType.GET_CORRECTION_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }

    default:
      return state
  }
}

export default Correction
